import { TurnawayLog } from "@/features/shelter/TurnawayLog";

export function TurnawayLogPage() {
  return <TurnawayLog />;
}
